import React from 'react';

const EmployeesTab = ({ employees, onAdd, onRemove }) => (
  <div style={{ width: '100%' }}>
    <div style={{
      backgroundColor: 'var(--card-bg)', border: '1px solid var(--border)',
      borderRadius: '0.375rem', boxShadow: '0 0.125rem 0.25rem rgba(0,0,0,0.075)',
      marginBottom: '1rem'
    }}>
      <div style={{
        padding: '0.75rem 1rem', borderBottom: '1px solid var(--border)',
        backgroundColor: 'var(--bg)', display: 'flex',
        justifyContent: 'space-between', alignItems: 'center'
      }}>
        <h5 style={{ margin: 0, fontWeight: '600', color: 'var(--text-secondary)', fontSize: '1rem' }}>
          Przypisania pracownikow
        </h5>
        <button
          style={{
            padding: '6px 12px', fontSize: '12px', fontWeight: '500',
            color: '#fff' , backgroundColor: 'var(--success)', border: '1px solid var(--success)',
            cursor: 'pointer'
          }}
          onClick={onAdd}
        >
          Przypisz
        </button>
      </div>
      <div style={{ padding: '1rem' }}>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: 'var(--bg)' }}>
                {['Uzytkownik', 'Magazyn', 'Rola', 'Akcje'].map(h => (
                  <th key={h} style={{ padding: '0.5rem', textAlign: 'left', borderBottom: '1px solid var(--border)', fontSize: '0.8rem', fontWeight: '600' }}>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {employees.map(employee => (
                <tr key={employee.id} style={{ borderBottom: '1px solid var(--border)' }}>
                  <td style={{ padding: '0.5rem', fontSize: '0.875rem' }}>{employee.login}</td>
                  <td style={{ padding: '0.5rem' }}>
                    <small style={{ color: 'var(--text-muted)' }}>{employee.warehouseName || 'Nieznany magazyn'}</small>
                  </td>
                  <td style={{ padding: '0.5rem' }}>
                    <span style={{
                      backgroundColor: employee.rola === 'kierownik' ? 'var(--danger)' : employee.rola === 'zastepca' ? 'var(--warning)' : employee.rola === 'pracownik' ? 'var(--info)' : 'var(--text-muted)',
                      color: '#fff' , padding: '0.25rem 0.5rem', borderRadius: '0.25rem', fontSize: '0.75rem', fontWeight: '500'
                    }}>
                      {employee.rola}
                    </span>
                  </td>
                  <td style={{ padding: '0.5rem' }}>
                    <button
                      style={{ padding: '4px 10px', fontSize: '11px', fontWeight: '500', color: '#fff' , backgroundColor: 'var(--danger)', border: '1px solid var(--danger)', cursor: 'pointer' }}
                      onClick={() => onRemove(employee.warehouseId, employee.user_login || employee.login)}
                    >
                      Usun
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
);

export default EmployeesTab;
